export class RoundTheBoardPlayer {
    constructor(name, rounds) {
        this.rounds = [];
        this.history = [];
        this.name = name;
        for (const round of rounds) {
            this.rounds.push(new Round(round, 0, 0));
        }
    }
}
export class Round {
    constructor(round, scoreInRound, totalAfterRound) {
        this.round = round;
        this.scoreInRound = scoreInRound;
        this.totalAfterRound = totalAfterRound;
    }
}
